import { ApiState } from "@/store/general.types";

export interface AccountState {
    getAccount: ApiState<AccountDetail>;
    getParticipantAuthority: ApiState<ParticipantAuthority>
}

export interface AccountDetail {
    id: number
    email: string;
    username: string;
    firstName: string
    lastName: string;
    projectRoles: { [key: number]: Array<string> };
    roles: Array<string>;
    langKey: string;
    enabled: boolean;
}

export enum Authority {
    // CONFLICT RESOLVER ROLES
    ROLE_FULL_TEXT_CONFLICT_RESOLVER = 'ROLE_FULL_TEXT_CONFLICT_RESOLVER',
    ROLE_TITLE_ABSTRACT_CONFLICT_RESOLVER = 'ROLE_TITLE_ABSTRACT_CONFLICT_RESOLVER',
    // PROJECT ROLES
    ROLE_PROJECT_OWNER = 'ROLE_PROJECT_OWNER',
    ROLE_UNLICENCED_PROJECT_OWNER = 'ROLE_UNLICENCED_PROJECT_OWNER',
    ROLE_PRIVILEGED_REVIEWER = 'ROLE_PRIVILEGED_REVIEWER',
    ROLE_REVIEWER = 'ROLE_REVIEWER',
}

export interface ParticipantAuthority {
    id: number,
    entityName: string,
    projectId: number,
    userId: number,
    inviteId: number,
    created: number,
    participantAuthorities: [
        {
            participantId: number,
            authority: Authority
        }
    ]
}

export interface ParticipantAuthorityPayload {
    projectId: number;
    userId: number;
}